"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AzureAdAppRegistrationToken = void 0;
/**
 * A token issued for an Azure Active Directory App Registration.
 */
class AzureAdAppRegistrationToken {
}
exports.AzureAdAppRegistrationToken = AzureAdAppRegistrationToken;
//# sourceMappingURL=azureAdAppRegistrationToken.js.map